import { ISoftData, ISoftTab, ICategorys } from "@/common/interface";
import { IIndexState } from "@/store/index";
import classnames from "classnames";
import React, { useState, useRef, useEffect } from "react";
import { connect } from "react-redux";
import SoftCell from "../../common/SoftCell";
import { useInViewport } from "ahooks";
import { sendClkLog } from "@/common/selfMonitor";
import { comMonitor, replaceUrlTemplate } from "@/utils/com";

import "./index.scss";

interface IProps {
  data: ISoftTab[];
}

interface ITitleProps {
  title: string;
  index: number;
  currentIndex: number;
  onClick: () => void;
}

interface IItemProps {
  data: ISoftData;
  title: string;
}
interface MainProps {
  index: number;
  currentIndex: number;
  items: ISoftTab;
  children: JSX.Element[];
}

const HotTabItem = (props: IItemProps) => {
  const {
    data: { clktk },
  } = props;
  const [startTime, setStartTime] = useState(0);
  const onMouseDown = (e: React.MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();
    setStartTime(Date.now());
  };

  const onMouseUp = (e: React.MouseEvent) => {
    if (Array.isArray(clktk) && clktk.length) {
      const now = Date.now();
      clktk.forEach((url) => {
        const realUrl = replaceUrlTemplate(url, e, startTime, now);
        comMonitor(realUrl);
      });
    }
  };
  return (
    <li
      onMouseDown={onMouseDown}
      onMouseUp={onMouseUp}
      className="hot-tab__item"
    >
      <SoftCell
        className="soft-cell--md"
        data={props.data}
        showBtn={true}
        supportLink={true}
        position={`mainsoft${props.title}`}
      />
    </li>
  );
};

const HotTabTitle = (props: ITitleProps) => {
  const { index, currentIndex, title, onClick } = props;
  return (
    <li
      className={classnames("hot-tab__title", {
        active: index === currentIndex,
      })}
      data-bk={title}
      onClick={onClick}
    >
      {title}
    </li>
  );
};

const MainLists = (props: MainProps) => {
  const { items, index, currentIndex } = props;

  const nodeRef = useRef<HTMLUListElement>(null);
  const [lock, setLock] = useState(false);
  const [inViewport, ratio] = useInViewport(nodeRef, {
    threshold: [0.1, 0.5, 1],
  });
  // const { soft_id, name } = items.data[index];
  // console.log("data is",items.data )

  useEffect(() => {
    if (inViewport && !lock && ratio && ratio >= 0.1 && items.data[0].soft_id) {
      const monitorIds = items.data
        .reduce<string>((prev, current) => {
          return (
            prev +
            "|" +
            `${current.soft_id}$${current.name}$${
              current.category && current.category.length
                ? ICategorys[current.category]
                : ICategorys[1]
            }`
          );
        }, "")
        .slice(1);

      const params = {
        cid: `mainsoft${items.title}`, //事件名称组名
        // c : "下载", //事件名称
        // from: (category && category.length) ? ICategorys[category] : '',
        title: monitorIds,
      };
      sendClkLog(params, "track");
      setLock(true);

      const urlItems = items.data.filter((item) => {
        return item.imptk;
      });
      urlItems.forEach((item) => {
        item.imptk.forEach((img: string) => {
          comMonitor(img);
        });
      });
    }
  }, [inViewport, items, lock, ratio]);

  const list = items.data
    .slice(0, 16)
    .map((item, i) => (
      <HotTabItem
        title={items.title}
        key={`${item.category}_${item.soft_id || i}`}
        data={item}
      />
    ));
  return (
    <ul
      ref={nodeRef}
      data-bk={items.title}
      key={items.title}
      className={classnames("hot-tab__list", {
        active: index === currentIndex,
      })}
    >
      {list}
    </ul>
  );
};

const HotTab = (props: IProps) => {
  const { data } = props;
  const [currentIndex, setCurrentIndex] = useState(0);

  const [HeaderList, MainList] = data.reduce<
    [React.ReactNode[], React.ReactNode[]]
  >(
    ([_HeaderList, _MainList], items, index) => {
      const list = items.data
        .slice(0, 16)
        .map((item, i) => (
          <HotTabItem title={items.title} key={item.soft_id || i} data={item} />
        ));

      _HeaderList.push(
        <HotTabTitle
          key={items.title}
          title={items.title}
          index={index}
          currentIndex={currentIndex}
          onClick={() => {
            setCurrentIndex(index);
            monitor &&
              monitor.log({
                c: items.title,
              });
          }}
        />,
      );

      _MainList.push(
        <MainLists
          key={items.title}
          index={index}
          currentIndex={currentIndex}
          items={items}
        >
          {list}
        </MainLists>,
      );

      return [_HeaderList, _MainList];
    },
    [[], []],
  );

  return (
    <div className="hot-tab" data-bk="tab">
      <ul className="hot-tab__header clearfix">{HeaderList}</ul>
      <div className="hot-tab__body">{MainList}</div>
    </div>
  );
};

const mapStateToProps = ({ indexData: { soft } }: IIndexState) => ({
  data: soft,
});

export default connect(mapStateToProps)(HotTab);
